import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Phone, Mail } from "lucide-react";
import { GoogleRatingBadge } from "@/components/site/GoogleRatingBadge";

const WHATSAPP_URL = "https://wa.me/918368975987";
const INSTAGRAM_HANDLE = "tiramisuandco._";
const INSTAGRAM_URL = `https://instagram.com/${INSTAGRAM_HANDLE}`;

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-line bg-ivory-100 pb-16 md:pb-0">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-24 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="font-serif text-3xl md:text-4xl tracking-[0.06em] text-espresso font-semibold">
            TIRAMISÙ <span className="text-gold">&amp;</span> Co.
          </div>
          <p className="mt-6 text-espresso-light max-w-sm italic font-serif text-lg leading-relaxed">
            One Spoon Closer to Happiness.
          </p>
          <p className="mt-6 text-sm text-espresso-light leading-relaxed max-w-sm">
            A boutique brand, layered by hand — every day, every cup.<br/>
            Ghaziabad · Delhi NCR (select pincodes).
          </p>
          <div className="mt-6">
            <GoogleRatingBadge variant="footer" />
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="label-xs text-espresso-light mb-5">Explore</div>
          <ul className="space-y-3 text-espresso">
            <li><Link to="/menu" className="link-underline">Menu</Link></li>
            <li><Link to="/bulk" className="link-underline">Bulk orders</Link></li>
            <li><Link to="/about" className="link-underline">Our story</Link></li>
            <li><Link to="/faq" className="link-underline">FAQ</Link></li>
            <li><Link to="/track" className="link-underline">Track order</Link></li>
          </ul>
          <div className="label-xs text-espresso-light mt-10 mb-5">Ghaziabad</div>
          <p className="text-sm text-espresso leading-relaxed" data-testid="footer-address">
            H-298 Govindpuram,<br/>
            Ghaziabad, Uttar Pradesh — 201013
          </p>
          <p className="text-xs text-espresso-light mt-3">Kitchen hours · 12:00 PM – 3:00 AM</p>
        </div>

        <div className="md:col-span-4">
          <div className="label-xs text-espresso-light mb-6">Get in touch</div>
          <ul className="space-y-4" data-testid="footer-contact">
            <li>
              <a
                href={WHATSAPP_URL}
                target="_blank" rel="noreferrer"
                data-testid="footer-whatsapp"
                className="group flex items-center gap-4 text-espresso hover:text-gold-hover transition-colors"
              >
                <span className="w-10 h-10 rounded-full border border-line group-hover:border-gold flex items-center justify-center transition-colors">
                  <MessageCircle size={16} strokeWidth={1.5} />
                </span>
                <span>
                  <span className="label-xs block text-espresso-light group-hover:text-gold-hover">WhatsApp</span>
                  <span className="font-serif text-lg">+91 83689 75987</span>
                </span>
              </a>
            </li>
            <li>
              <a
                href="tel:+918368975987"
                data-testid="footer-phone"
                className="group flex items-center gap-4 text-espresso hover:text-gold-hover transition-colors"
              >
                <span className="w-10 h-10 rounded-full border border-line group-hover:border-gold flex items-center justify-center transition-colors">
                  <Phone size={16} strokeWidth={1.5} />
                </span>
                <span>
                  <span className="label-xs block text-espresso-light group-hover:text-gold-hover">Phone</span>
                  <span className="font-serif text-lg">+91 83689 75987</span>
                </span>
              </a>
            </li>
            <li>
              <a
                href="mailto:hello@tiramisuandco.in"
                data-testid="footer-email"
                className="group flex items-center gap-4 text-espresso hover:text-gold-hover transition-colors"
              >
                <span className="w-10 h-10 rounded-full border border-line group-hover:border-gold flex items-center justify-center transition-colors">
                  <Mail size={16} strokeWidth={1.5} />
                </span>
                <span>
                  <span className="label-xs block text-espresso-light group-hover:text-gold-hover">Email</span>
                  <span className="font-serif text-lg">hello@tiramisuandco.in</span>
                </span>
              </a>
            </li>
            <li>
              <a
                href={INSTAGRAM_URL}
                target="_blank" rel="noreferrer"
                data-testid="footer-instagram"
                className="group flex items-center gap-4 text-espresso hover:text-gold-hover transition-colors"
              >
                <span className="w-10 h-10 rounded-full border border-line group-hover:border-gold flex items-center justify-center transition-colors">
                  <Instagram size={16} strokeWidth={1.5} />
                </span>
                <span>
                  <span className="label-xs block text-espresso-light group-hover:text-gold-hover">Instagram</span>
                  <span className="font-serif text-lg">@{INSTAGRAM_HANDLE}</span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-line">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row justify-between gap-4 text-xs text-espresso-light">
          <div>© {new Date().getFullYear()} TIRAMISÙ &amp; Co. All rights reserved.</div>
          <div className="flex flex-wrap gap-6" data-testid="footer-compliance">
            <span>FSSAI · <span className="text-espresso">22726699000251</span></span>
            <span>GSTIN · <span className="text-espresso">09BQDPG9836N1Z5</span></span>
            <span className="text-espresso-light/70">Privacy</span>
            <span className="text-espresso-light/70">Terms</span>
            <span className="text-espresso-light/70">Refunds</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
